export const BREAK_MOBILE = 540
export const BREAK_TABLET = 1024
export const BREAK_LARGE = 1248
export const BREAK_EXTRA_LARGE = 1500

const breakpointsAscending = [
  BREAK_MOBILE,
  BREAK_TABLET,
  BREAK_LARGE,
  BREAK_EXTRA_LARGE
]
const breakpointsDescending = Array.from(breakpointsAscending).reverse()

/**
 * @param arr same array you can use with chakra styling-array of up to 4 values
 */
export function getValueForScreenSize<T>(arr: T[]): T | undefined {
  const { innerWidth } = window

  let i = breakpointsAscending.length - 1
  if (arr.length === 0) {
    return
  }
  for (const breakpoint of breakpointsDescending) {
    if (innerWidth > breakpoint) {
      if (arr[i]) {
        return arr[i]
      }
    }
    if (i === 0) {
      return arr[i]
    }
    i--
  }
}
